export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10033.cd29b5a6.jpg";